<template>
  <div>
    <div>
      {{ inscription.prenom }} {{ inscription.nom }} souhaite vous transférer son inscription au parcours suivant: <b>{{
        inscription.course.nom }}</b>
    </div>
    <div v-if="selected_course.vagues && selected_course.vagues.list.length > 0">
      <div class="mt-3">
        <v-radio-group label="Choix de la vague de départ" v-model="selected_course.vague_selected">
          <v-radio class="radio_vagues" color="primary-dark" hide-details
            v-for="(vague, index_vague) in selected_course.vagues.list" :key="index_vague" :value="vague.id"
            :disabled="!vague.is_available()">
            <template v-slot:label>
              <div>
                {{ vague.nom }}
                <span v-if="vague.places_restantes > 0 && vague.places_restantes < 1000">({{ vague.places_restantes }}
                  places restantes)</span>
                <span v-if="vague.places_restantes <= 0"> (complet)</span>
              </div>
            </template>
          </v-radio>
        </v-radio-group>
      </div>
    </div>

    <div class="mt-2" v-if="inscription.commande_options && inscription.commande_options.length > 0">
      Avec cette inscription, vous béneficierez des options/activités suivantes:
      <div class="mt-2 d-flex sm-gap">
        <v-chip v-for="option in inscription.commande_options" :key="option.id" class="bg-grey_1" variant="outlined"
          text-color="darkblue" color="darkblue">
          <template v-slot:prepend>
            <v-avatar class="text-primary-dark">
              <b>{{ option.quantite }}x</b>
            </v-avatar>
          </template>
          <div>{{ option.nom }}</div>
        </v-chip>
      </div>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import List_Courses from "@/classes/Courses/List_Courses.class.js";
export default {
  props: ["inscription"],
  data() {
    return {
      list_courses: null,
      selected_course: {},
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  watch: {
    "selected_course.vague_selected"() {
      this.$emit("update_vague", this.selected_course.vague_selected);
    },
  },
  methods: {
    async get_course() {
      this.list_courses = new List_Courses(this.mainStore.module.id)
      this.list_courses.initialize_from_mainstore(this.mainStore.module.courses.list);
      this.selected_course = this.list_courses.list.find((course) => course.id == this.inscription.course.id);

      for (let i = 0; i < this.selected_course.vagues.list.length; i++) {
        if (this.selected_course.vagues.list[i].id == this.inscription.id_vague_course) {
          this.selected_course.vague_selected = this.inscription.id_vague_course;
          this.selected_course.vagues.list[i].selected = true;
          this.selected_course.vagues.list[i].nb_inscrits -= 1;
          this.selected_course.vagues.list[i].places_restantes += 1;

          break;
        }
      }
    },
  },
  async created() {
    await this.get_course();
  },
};
</script>

<style lang="scss" scoped></style>